import GraphBox from './GraphBox';

export default GraphBox;
